import { styled } from "@mui/material";
import { NavigationItem, TabBarContainer } from "@navigation/TopNavigation/TabBar/TabBar.styled";
import { maxPageContentWidth } from "@constants/consts";
import { colors } from "@constants/cssVariables";

export const SeriesTabBarContainer = styled(TabBarContainer)(({ theme }) => ({
  position: "relative",
  zIndex: 1,
  marginTop: theme.spacing(5),
  backgroundColor: colors.neutral0,
  [theme.breakpoints.up("md")]: {
    marginTop: theme.spacing(8),
  },
  [`${NavigationItem}`]: {
    color: colors.neutral80,

    "&[aria-current=true]": {
      borderColor: colors.primary,
    },

    [theme.breakpoints.up("md")]: {
      "&:hover": {
        borderColor: colors.primary,
      },
    },
  },
}));

export const SeriesTabBarContent = styled("div")(({ theme }) => ({
  position: "relative",
  display: "flex",
  alignItems: "center",
  gap: theme.spacing(2),
  height: "100%",
  maxWidth: maxPageContentWidth,
  margin: "0 auto",

  [theme.breakpoints.up("md")]: {
    padding: theme.spacing(0, 8),
  },

  [theme.breakpoints.up("lg")]: {
    padding: theme.spacing(0, 24),
  },

  [theme.breakpoints.between("md", "lg")]: {
    paddingLeft: theme.spacing(20),
    paddingRight: theme.spacing(20),
  },
}));
